"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const store_1 = require("../../context/store");
const common_1 = require("../../utils/common");
const react_1 = require("react");
const DayOfWeekText = (props) => {
    const { width, day } = props;
    const [store] = (0, react_1.useContext)(store_1.Context);
    const { translations } = store;
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'Kalend__CalendarHeaderWeekDays__col', style: { width } }, { children: (0, jsx_runtime_1.jsx)("p", Object.assign({ className: (0, common_1.parseCssDark)('Kalend__text Kalend__CalendarHeaderWeekDays__text', store.isDark) }, { children: translations['weekDays'][`${day.toFormat('EEE')}`] })) })));
};
exports.default = DayOfWeekText;
